import { Component, ViewChild } from '@angular/core';
import { ContactUsRequest } from '@shared/models/request/contact-us-request.model';
import { ContactUsService } from '@shared/services/contact-us.service';
import { ContactFormComponent, ContactFormStatus } from '@shared/components/contact-form/contact-form.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {

  @ViewChild(ContactFormComponent) contactForm: ContactFormComponent;

  status: ContactFormStatus = 'idle';

  constructor(private contactUsService: ContactUsService) {}

  onSubmit(request: ContactUsRequest): void {
    this.status = 'submitting';
    this.contactUsService.sendContactUsEmail(request).subscribe(
      () => {
        this.status = 'success';
        this.contactForm?.reset();
      },
      () => {
        this.status = 'error';
      }
    );
  }
}
